// BaseAddressInfo.js
export default class BaseAddressInfo {
  constructor(data = {}) {
    this.streetName = data.streetName || '';
    this.postalCode = data.postalCode || '';
    this.province = data.province || '';
    this.region = data.region || '';
    this.country = data.country || '';
    this.latitude = data.latitude || '';
    this.longitude = data.longitude || '';
    this.fullAddress = data.fullAddress || '';
    this.streetNumber = data.streetNumber || '';
    this.city = data.city || '';
    this.locality = data.locality || '';
  }

  toMap() {
    return {
      streetName: this.streetName,
      postalCode: this.postalCode,
      province: this.province,
      region: this.region,
      country: this.country,
      latitude: this.latitude,
      longitude: this.longitude,
      fullAddress: this.fullAddress,
      streetNumber: this.streetNumber,
      city: this.city,
      locality: this.locality,
      
    };
  }

  toFullAddress() {
    return [
      this.streetNumber,
      this.streetName,
      this.locality || this.city,
      this.region,
      this.province,
      this.postalCode,
      this.country
    ].filter(Boolean).join(', ');
  }

  toShortAddress() {
    return [
      `${this.streetName} ${this.streetNumber}`,
      this.locality || this.city
    ].filter(Boolean).join(', ');
  }

  toShortAddressWithoutCity() {
    return [
      `${this.streetName} ${this.streetNumber}`
    ].filter(Boolean).join(', ');
  }
}
